export const reInfoOrgConstants = {
	Create: {
		FAILURE : 'CREATE_INFO_ORG_FAILURE',
		REQUEST : 'CREATE_INFO_ORG_REQUEST',
		SUCCESS : 'CREATE_INFO_ORG_SUCCESS'
	},
	Update: {
		FAILURE : 'UPDATE_INFO_ORG_FAILURE',
		REQUEST : 'UPDATE_INFO_ORG_REQUEST',
		SUCCESS : 'UPDATE_INFO_ORG_SUCCESS'
	},
	Delete: {
		FAILURE : 'DELETE_INFO_ORG_FAILURE',
		REQUEST : 'DELETE_INFO_ORG_REQUEST',
		SUCCESS : 'DELETE_INFO_ORG_SUCCESS'
	},
	Restore: {
		FAILURE : 'RESTORE_INFO_ORG_FAILURE',
		REQUEST : 'RESTORE_INFO_ORG_REQUEST',
		SUCCESS : 'RESTORE_INFO_ORG_SUCCESS'
	},
	GetPaged: {
		FAILURE : 'GET_PAGED_INFO_ORG_FAILURE',
		REQUEST : 'GET_PAGED_INFO_ORG_REQUEST',
		SUCCESS : 'GET_PAGED_INFO_ORG_SUCCESS'
	},
	GetList: {
		FAILURE : 'GET_LIST_INFO_ORG_FAILURE',
		REQUEST : 'GET_LIST_INFO_ORG_REQUEST',
		SUCCESS : 'GET_LIST_INFO_ORG_SUCCESS'
	},
	GetListByRoles: {
		FAILURE : 'GET_LIST_INFO_ORG_BY_ROLES_FAILURE',
		REQUEST : 'GET_LIST_INFO_ORG_BY_ROLES_REQUEST',
		SUCCESS : 'GET_LIST_INFO_ORG_BY_ROLES_SUCCESS'
	},
	Upload: {
		FAILURE : 'UPLOAD_INFO_ORGS_FILE_FAILURE',
		REQUEST : 'UPLOAD_INFO_ORGS_FILE_REQUEST',
		SUCCESS : 'UPLOAD_INFO_ORGS_FILE_SUCCESS'
	},
	GetExampleFile: {
		FAILURE : 'DOWNLOAD_EXAMPLE_FILE_FAILURE',
		REQUEST : 'DOWNLOAD_EXAMPLE_FILE_REQUEST',
		SUCCESS : 'DOWNLOAD_EXAMPLE_FILE_SUCCESS'
	},
	CLEAR: 'CLEAR_INFO_ORG'
}